import { useAuth0 } from '@auth0/auth0-react';
import { Navigate, useLocation } from 'react-router';
import { useContext } from 'react';
import Dashboard from 'components/Dashboard';
import { dataHubUsers } from 'components/Dashboard/SidebarElements/parliamentarianUsers';
import { store } from 'components/Store';

const DataHubRedirect = () => {
  const location = useLocation();
  const { isAuthenticated } = useAuth0();
  const { state } = useContext(store);
  const { activePlan } = state ?? {};

  if (isAuthenticated && Object.keys(activePlan).length > 0 && !dataHubUsers(activePlan)) {
    const newPath = location.pathname.replace('/data-hub', '/analytics');
    const search = location.search;
    return <Navigate replace to={`${newPath}${search}`} />;
  }

  return <Dashboard />;
};

export default DataHubRedirect;
